import Vue from 'vue'
import GoogleMapsApiLoader from 'google-maps-api-loader'
import config from '@/config'

Vue.prototype.$googleMaps = GoogleMapsApiLoader({
  apiKey: config.googleApiKey,
})

declare module 'vue/types/vue' {
  interface Vue {
    $googleMaps: any
  }
}
